import { render, staticRenderFns } from "./ConventionCase.vue?vue&type=template&id=2ab5bcdd&scoped=true"
import script from "./ConventionCase.vue?vue&type=script&lang=js"
export * from "./ConventionCase.vue?vue&type=script&lang=js"
import style0 from "./ConventionCase.vue?vue&type=style&index=0&id=2ab5bcdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5bcdd",
  null
  
)

export default component.exports